export const environment = {
  version: '0.1.1',
  production: true
};
